import { getToken } from "./auth";

export const API_URL = "https://ohms.gbu.ac.in/api/index.php?route=";

async function readApiResponse(res) {
  const text = await res.text();
  let data = {};

  if (text.trim()) {
    try {
      data = JSON.parse(text);
    } catch (err) {
      data = { error: text.trim() };
    }
  }

  if (!res.ok) {
    return {
      ...data,
      error: data.error || `Request failed with status ${res.status}`,
      status: res.status,
    };
  }

  return data;
}

export async function apiGet(route) {
  const token = getToken();
  const res = await fetch(API_URL + route, {
    headers: {
      Authorization: "Bearer " + token
    }
  });
  // if (res.status === 401) {
  //   // Token expired or invalid
  //   removeToken();
  //   window.location.href = "/"; // force redirect to login
  //   return; // stop here
  // }
  return readApiResponse(res);
}

export async function apiPost(route, body) {
  const token = getToken();
  const res = await fetch(API_URL + route, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });

  return readApiResponse(res);
}

/**
 * Non-auth POST (for forgot password)
 */
export async function apiPostNoAuth(route, body) {
  const res = await fetch(API_URL + route, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });
  return readApiResponse(res);
}


/**
 * Fetch fees data
 */
export async function fetchFees() {
  const token = getToken();
  const res = await fetch(API_URL + "fees", {
    headers: {
      Authorization: "Bearer " + token
    }
  });
  // if (res.status === 401) {
  //   // Token expired or invalid
  //   removeToken();
  //   window.location.href = "/"; // force redirect to login
  //   return; // stop here
  // }
  return readApiResponse(res);
}

/**
 * Refresh fees data
 */
export async function refreshFees() {
  const token = getToken();
  const res = await fetch(API_URL + "fees&action=refresh", {
    headers: {
      Authorization: "Bearer " + token
    }
  });
  // if (res.status === 401) {
  //   // Token expired or invalid
  //   removeToken();
  //   window.location.href = "/"; // force redirect to login
  //   return; // stop here
  // }
  return readApiResponse(res);
}

export async function fetchHostelHistory() {
  const token = getToken();
  const res = await fetch(API_URL + "getHostelHistory", {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return readApiResponse(res);
}

